import { Component, OnInit } from '@angular/core';
import { HealthService } from '../../_services/health.service';

@Component({
  selector: 'app-health',
  templateUrl: './health.component.html',
  styleUrls: ['./health.component.scss']
})
export class HealthComponent implements OnInit {
  healthData: any = {};
  constructor(private healthService: HealthService,) { }

  ngOnInit() {
    this.healthService.getHealth().subscribe(data => {
      this.healthData = (JSON.stringify(data));
      console.log(this.healthData);
    });
  }

}
